import { useState, useEffect } from "react"
import { useAddNewUserMutation } from "./usersApiSlice"
import { useNavigate } from "react-router-dom"
import { ROLES } from "../../config/roles"
import useTitle from "../../hooks/useTitle"
import { useGetOrganizacijaNamesQuery } from "../organizacija/organizacijaApiSlice"
import { useGetTipUgovoraNamesQuery } from "../podaci/tipUgovora/tipUgovoraApiSlice"
import { useGetSektorNamesQuery } from "../podaci/sektor/sektorApiSlice"
import { useGetPozicijeNamesQuery } from "../podaci/pozicije/pozicijeApiSlice"
import { addPosition } from "./userPositionDataSlice"
import { useDispatch } from 'react-redux'

//SREDJUJ OVO
const NewRadnikuOrganizacijiForm = ({ onClose }) => {
    useTitle('Dodaj korisnika');

    //User data
    const [organizacije, setOrganizacije] = useState([]);   //Sve organizacije 

    const [organizacijaId, setSelectedOrganizacijaId] = useState('');   //extratovan id
    const [organizacijaName, setSelectedOrganizacijaName] = useState('');   //extratovan name

    const [pozcicije, setPozicije] = useState([]);
    const [pozcicijaName, setPozicijaName] = useState('');
    const [pozcicijaId, setPozicijaId] = useState('');
    const [pozcicijaDnevnica, setPozicijaDnevnica] = useState('');

    const [tipUgovora, setTipUgovora] = useState([]);
    const [tipUgovoraName, setTipUgovoraName] = useState('');
    const [tipUgovoraId, setTipUgovoraId] = useState('');

    const [sektori, setSektori] = useState([]);
    const [sektorName, setSektorName] = useState('');
    const [sektorId, setSektorId] = useState('');

    const [netoPlataUgovor, setNetoPlataUgovor] = useState('')
    const [fixUgovoren, setFixUgovoren] = useState('')

    //
    const [roles, setRoles] = useState([]);

    const [hasErrors, setHasErrors] = useState();

    const [newUserFormSection, setNewUserFormSection] = useState(false);

    const [isModalOpenSuccess, setIsModalOpenSuccess] = useState(false);
    const [isModalDupli, setIsModalDupli] = useState(false);

    //ZA RADIO GROUP data
    const [selectedOptionKafa, setSelectedOptionKafa] = useState();
    const [selectedOptionDnevnica, setSelectedOptionDnevnica] = useState();

    const { data: organizacijeData, isLoading: isLoadingOrganizacije, isError: isErrorOrganizacije } = useGetOrganizacijaNamesQuery("organizacijeNames");
    const { data: tipUgovoraData, isLoading: isLoadingTipUgovora, isError: isErrorTipUgovora } = useGetTipUgovoraNamesQuery("tipUgovoraNames");
    const { data: sektorData, isLoading: isLoadingSektor, isError: isErrorSektor } = useGetSektorNamesQuery("sektorNames");
    const { data: pozicijeData, isLoading: isLoadingPozicije, isError: isErrorPozicije } = useGetPozicijeNamesQuery("pozicijeNames");

    useEffect(() => {
        if (organizacijeData && tipUgovoraData && sektorData && pozicijeData) {
            // console.log("ORGANIZACIJA:",organizacijeData);
            // console.log("TIP UGOVORA:",tipUgovoraData);
            // console.log("SEKTOR:",sektorData);
            // console.log("POZICIJE:",pozicijeData);
            setOrganizacije(organizacijeData);
            setTipUgovora(tipUgovoraData);
            setSektori(sektorData);
            setPozicije(pozicijeData);
            

        }
    }, [organizacijeData,tipUgovoraData,sektorData,pozicijeData]);


    //User from
    const openNewUserFormSection = () => setNewUserFormSection(true);
    
    //Modal
    const openModalSuccess = () => setIsModalOpenSuccess(true);
    const openModalDupli = () => setIsModalDupli(true);
    const closeModalSuccess = () => setIsModalOpenSuccess(false);
    const closeModalDupli = () => setIsModalDupli(false);

    const navigate = useNavigate();
    const dispatch = useDispatch()

    const [addNewUser, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewUserMutation();

    //Error fealds
    const [fieldErrors, setFieldErrors] = useState({
        netoPlataUgovor: false,
        fixUgovoren: false,
        // username: false,
        // password: false,
        // password2: false,
        // address: false,
        // phone: false,
        // roles: false
    });

    // useEffect(() => {
    //     if (!isError) {
    //         setName('');
    //         setLastName('');
    //         setUsername('');
    //         setPassword('');
    //         setPassword2('');
    //         setAddress('');
    //         setPhone('');
    //         setRoles([]);
    //         // openModalSuccess();
    //     }
    // }, [isSuccess, navigate])



    //Setters
    const handleOptionChangeKafa = (e) => {
        setSelectedOptionKafa(e.target.value);
    };

    const handleOptionChangeDnevnica = (e) => {
        setSelectedOptionDnevnica(e.target.value);
    };

    //
    const onNetoPlataUgovorChanged = e => {
        setNetoPlataUgovor(e.target.value)
        if (fieldErrors.netoPlataUgovor) setFieldErrors(prev => ({...prev, netoPlataUgovor: false}));
    }

    const onFixUgovorenChanged = e => {
        setFixUgovoren(e.target.value);
        if (fieldErrors.fixUgovoren) setFieldErrors(prev => ({...prev, fixUgovoren: false}));
    }

    //Setters for selectors 
    const handleSelectOrganizacija = (event) => {
        const selectedOrg = organizacije.find(org => org._id === event.target.value);
        setSelectedOrganizacijaId(event.target.value);
        setSelectedOrganizacijaName(selectedOrg.name);
    };

    const handleSelectPozicije = (event) => {
        setPozicijaName(event.target.value);
        setPozicijaId(pozicijeData.find((item)=>item.naziv == event.target.value)._id)
        setPozicijaDnevnica(pozicijeData.find((item)=>item.naziv == event.target.value).dnevnica)
    };

    const handleSelectSektor = (event) => {
        setSektorName(event.target.value);
        setSektorId(sektorData.find((item)=>item.name == event.target.value)._id)
    };

    const handleSelectTipUgovora = (event) => {
        setTipUgovoraName(event.target.value);
        setTipUgovoraId(tipUgovoraData.find((item)=>item.name == event.target.value)._id)
    };

    const onRolesChanged = e => {
        const values = Array.from(
            e.target.selectedOptions, //HTMLCollection 
            (option) => option.value
        )
        setRoles(values);

        if (e.target.value === 'Editor') {
            setNewUserFormSection(true);
        } else {
            setNewUserFormSection(false);
        }
    }

    const options = Object.values(ROLES)
        .filter(role => role !== 'Klijent')
        .map(role => {
            return <option key={role} value={role}>{role}</option>;
        }
    );

    useEffect(() => {
        // Set the first non-Klijent role as the default
        const firstRole = Object.values(ROLES).find(role => role !== 'Klijent');
        setRoles(firstRole);
    }, []);

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ');
    }


    //OVDE SALJEM
    const handleConfirmSuccess = async () => {
        closeModalSuccess();
        onClose();
    };

    // const onSaveUserClicked = async (e) => {
    //     e.preventDefault();

         // Validation logic BOJE...
        const newFieldErrors = {
            fixUgovoren: fixUgovoren.trim() === '',
            fixUgovoren: fixUgovoren.trim() === '',
            // username: username.trim() === '',
            // password: password.trim() === '',
            // password2: password2.trim() === '',
            // jmbg: jmbg.trim() === '',
            // plata: plata === '',
        };

    //     setFieldErrors(newFieldErrors);
    //     const hasFormErrors = Object.values(newFieldErrors).some(error => error);
    //     setHasErrors(hasFormErrors);

    //     if (!hasFormErrors) {
    //         if (!chekPassword(password, password2)) {
    //             openModalPassword();
    //             return; // Exit early if passwords don't match
    //         }

    //         try {
    //             // Attempt to add new user
    //             let response = await addNewUser({ name, lastName, username, password, jmbg, roles, plata, status: selectedOptionStatus,valuta: selectedOptionValuta }).unwrap();
    //             console.log('User added successfully:', response);
                
    //             // Call openModalSuccess if the request succeeds
    //             openModalSuccess();
    //         } catch (err) {
    //             console.error('Failed to add user:', err);
    //             // Handle error case
    //             openModalDupli();
    //         }
    //     }
    // };

    const onDodajPozicijuClicked = async (e) => {
        e.preventDefault();

        // Validation logic BOJE...
        const newFieldErrors = {
            netoPlataUgovor: netoPlataUgovor.trim() === '',
            fixUgovoren: fixUgovoren.trim() === '',
            // username: username.trim() === '',
            // password: password.trim() === '',
            // password2: password2.trim() === '',
            // jmbg: jmbg.trim() === '',
            // plata: plata === '',
        };

        setFieldErrors(newFieldErrors);
        const hasFormErrors = Object.values(newFieldErrors).some(error => error);
        setHasErrors(hasFormErrors);

        if (!hasFormErrors) {
            dispatch(addPosition( { organizacijaId,organizacijaName ,fixUgovoren,kafa: selectedOptionKafa, zaRacDnev: selectedOptionDnevnica, netopalataIzUgovora: netoPlataUgovor ,pozicija: {pozcicijaId: pozcicijaId, pozcicijaName: pozcicijaName, dnevnica: pozcicijaDnevnica}, tipUgovora: { tipUgovoraId:tipUgovoraId ,tipUgovoraName: tipUgovoraName} ,sektor: { sektorId: sektorId ,sektorName: sektorName } }));
            onClose();
            // console.log(organizacijaId,fixUgovoren,selectedOptionKafa, selectedOptionDnevnica, netoPlataUgovor ,pozcicijaName, tipUgovoraName,sektorName)
            // if (!chekPassword(password, password2)) {
            //     openModalPassword();
            //     return; // Exit early if passwords don't match
            // }

            // try {
            //     // Attempt to add new user
            //     let response = await addNewUser({ name, lastName, username, jmbg, roles, plata, status: selectedOptionStatus,valuta: selectedOptionValuta }).unwrap();
            //     console.log('User added successfully:', response);
                
            //     // Call openModalSuccess if the request succeeds
            //     openModalSuccess();
            // } catch (err) {
            //     console.error('Failed to add user:', err);
            //     // Handle error case
            //     openModalDupli();
            // }
        }
    };

    // const errClass = isError ? "text-red" : "text-black"

    //TailwindConetent
    const tailwindContent = (
        <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
            <form className="bg-white shadow-sm ring-2 ring-gray-900/5 sm:rounded md:col-span-3">
                <div className="px-3 py-3 sm:p-3">
                    <div className="grid max-w-2xl grid-cols-1 gap-x-3 gap-y-4 sm:grid-cols-3">

                        {/* Error message */}
                        {/* <p className={errClass}>{error?.data?.message}</p> */}

                        <div className="sm:col-span-2">
                            <label htmlFor="organizacija" className="block text-sm font-medium leading-6 text-gray-900">Organizacija</label>
                            <div className="mt-1">
                                {/* Throws error because value is not scalar... */}
                                {/* <select id="role" name="role" autoComplete="role" value={roles} onChange={onRolesChanged} className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6" >
                                    {options}
                                </select> */}
                                <select value={organizacijaId} onChange={handleSelectOrganizacija} className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6">
                                    <option value="" disabled>Izaberite</option>
                                    {organizacije.map(org => (
                                        <option key={org._id} value={org._id}>{org.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* <div>
                            Selected Organization ID: {organizacijaId}
                        </div> */}
                        <br />

                        <div className="sm:col-span-1">
                            <label htmlFor="pozicija" className="block text-sm font-medium leading-6 text-gray-900">Pozicija</label>
                            <div className="mt-1">
                                {/* Throws error because value is not scalar... */}
                                <select value={pozcicijaName} onChange={handleSelectPozicije} className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6">
                                    <option value="" disabled>Izaberite</option>
                                    {pozcicije.map(org => (
                                        <option key={org._id} value={org.naziv}>{org.naziv}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="sm:col-span-1">
                            <label htmlFor="sektor" className="block text-sm font-medium leading-6 text-gray-900">Sektor</label>
                            <div className="mt-1">
                                {/* Throws error because value is not scalar... */}
                                <select value={sektorName} onChange={handleSelectSektor} className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6">
                                    <option value="" disabled>Izaberite</option>
                                    {sektori.map(org => (
                                        <option key={org._id} value={org.name}>{org.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="sm:col-span-1">
                            <label htmlFor="tipUgovora" className="block text-sm font-medium leading-6 text-gray-900">Tip ugovora</label>
                            <div className="mt-1">
                                {/* Throws error because value is not scalar... */}
                                <select value={tipUgovoraName} onChange={handleSelectTipUgovora} className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6">
                                    <option value="" disabled>Izaberite</option>
                                    {tipUgovora.map(org => (
                                        <option key={org._id} value={org.name}>{org.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>


                        <div className="sm:col-span-3">
                            <label htmlFor="netoPlataUgovor" className="block text-sm font-medium leading-6 text-gray-900">Neto plata iz ugovora</label>
                            <div className="mt-1">
                                <input type="number" name="netoPlataUgovor" id="netoPlataUgovor" value={netoPlataUgovor} onChange={onNetoPlataUgovorChanged} autoComplete="netoPlataUgovor" className={`block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
                                        fieldErrors.netoPlataUgovor ? 'bg-red-100 ring-red-500 focus:ring-red-500' : 'ring-gray-300 focus:ring-indigo-600'
                                    }`} />
                            </div>
                        </div>

                        <div className="sm:col-span-3">
                            <label htmlFor="fixUgovoren" className="block text-sm font-medium leading-6 text-gray-900">Fix ugovoren</label>
                            <div className="mt-1">
                                <input type="number" name="fixUgovoren" id="fixUgovoren" value={fixUgovoren} onChange={onFixUgovorenChanged} autoComplete="fixUgovoren" className={`block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
                                        fieldErrors.fixUgovoren ? 'bg-red-100 ring-red-500 focus:ring-red-500' : 'ring-gray-300 focus:ring-indigo-600'
                                    }`} />
                            </div>
                        </div>

                        <div className="sm:col-span-3">
                            <fieldset className="flex items-center space-x-3">
                                <label className="text-sm font-semibold leading-6 text-gray-900">Da li pije kafu: </label>
                                <div className="space-y-6 sm:flex sm:items-center sm:space-x-1 sm:space-y-0">
                                    <div className="flex items-center">
                                        <input
                                            type="radio"
                                            value="Da"
                                            checked={selectedOptionKafa === 'Da'}
                                            onChange={handleOptionChangeKafa}
                                            className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                                        />
                                        <label htmlFor="Aktivan" className="ml-1 mr-3 block text-sm font-medium leading-6 text-gray-900">
                                            Da
                                        </label>
                                    </div>
                                    <div className="flex items-center">
                                        <input
                                            type="radio"
                                            value="Ne"
                                            checked={selectedOptionKafa === 'Ne'}
                                            onChange={handleOptionChangeKafa}
                                            className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                                        />
                                        <label htmlFor="Neaktivan" className="ml-1 mr-3 block text-sm font-medium leading-6 text-gray-900">
                                            Ne
                                        </label>
                                    </div>
                                </div>
                            </fieldset>
                        </div>

                        <div className="sm:col-span-3">
                            <fieldset className="flex items-center space-x-3">
                                <label className="text-sm font-semibold leading-6 text-gray-900">Da li se koristi za računanje dnevnica: </label>
                                <div className="space-y-6 sm:flex sm:items-center sm:space-x-1 sm:space-y-0">
                                    <div className="flex items-center">
                                        <input
                                            type="radio"
                                            value="Da"
                                            checked={selectedOptionDnevnica === 'Da'}
                                            onChange={handleOptionChangeDnevnica}
                                            className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                                        />
                                        <label htmlFor="Da" className="ml-1 mr-3 block text-sm font-medium leading-6 text-gray-900">
                                            Da
                                        </label>
                                    </div>
                                    <div className="flex items-center">
                                        <input
                                            type="radio"
                                            value="Ne"
                                            checked={selectedOptionDnevnica === 'Ne'}
                                            onChange={handleOptionChangeDnevnica}
                                            className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                                        />
                                        <label htmlFor="Ne" className="ml-1 mr-3 block text-sm font-medium leading-6 text-gray-900">
                                            Ne
                                        </label>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-end gap-x-2 border-t border-gray-900/10 px-2 py-2 sm:px-2">
                    <button onClick={onDodajPozicijuClicked} className="rounded bg-blue-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">Dodaj</button>
                </div>
            </form>
        </div>
    )

    return <>
            {/* template za svaku komponentu */}
            <div className="">
                {/* <header className="mb-3">
                    <div className="">
                        <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">Novi korisnik</h1>
                    </div>
                </header>
                <hr className="border-t border-slate-950" /> */}
                <main className="">
                    <div className="">
                        {/* <br/> */}
                        {tailwindContent}

                        {isModalOpenSuccess && (
                            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
                                <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
                                    <div className="mt-3 text-center">
                                        {!hasErrors ? 
                                            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100">
                                                <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </div> :
                                            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                                                <svg className="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                                </svg>
                                            </div> 
                                        }

                                        <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">{!hasErrors ? "Obaveštenje" : "Upozorenje"}</h3>

                                        <div className="mt-2 px-7 py-3">
                                        <p className="text-sm text-gray-500">{!hasErrors ? "Uspešno ste napravili novog korisnika" : "Morate uneti sva polja"}</p>
                                    </div>
                                    <div className="items-center px-4 py-3">
                                        <button onClick={!hasErrors ? handleConfirmSuccess : closeModalSuccess} className={!hasErrors ? "px-4 py-2 bg-blue-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300" : "px-4 py-2 bg-yellow-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300"}>Uredu</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}


                        {isModalDupli ? (
                            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
                                <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
                                    <div className="mt-3 text-center">
                                        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                                            <svg className="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                            </svg>
                                        </div> 
                                        <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">Upoznorenje</h3>
                                        <div className="mt-2 px-7 py-3">
                                        {/* <p className="text-sm text-gray-500">Korisnik postoji, unesi novog</p> */}
                                        <p className="text-sm text-gray-500">Korisnik postoji, unesite drugi jmbg</p>
                                    </div>
                                    <div className="items-center px-4 py-3">
                                        <button onClick={closeModalDupli} className="px-4 py-2 bg-yellow-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300">Ugasi</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )
                        
                        : null}

                        
                    </div>
                </main>
            </div>
        </>
}
export default NewRadnikuOrganizacijiForm
